export interface ResolveQuarantineDto {
	amountReturned: number;
	amountScrapped: number;
	quarantinedPartId: number;
}

export class ResolveQuarantineDto implements ResolveQuarantineDto {	
	constructor(data?: Partial<ResolveQuarantineDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}